import React, { FC } from 'react';

import { DangerouslySetInnerHtml, Layout } from 'layout';
import ConditionalTextSlider from 'layout/ConditionalTextSlider';
import ProductListComponent from 'layout/ProductListComponent';
import Image from 'common/Image';
import PageSchema from 'common/PageSchema';
import Seo from 'common/Seo';

import { ProductListingProps } from './models';

import './productListingComponent.scss';

const ProductListingComponent: FC<ProductListingProps> = ({
  node: {
    productMainBanner,
    section,
    seoMetaTitle,
    seoMetaDescription,
    seoMetaKeywords,
    purchaseLinkText,
    titlePage,
    conditionalSlider,
  },
}) => {
  const { slider, customClassName } =
    conditionalSlider !== undefined ? conditionalSlider[0] : { slider: [], customClassName: '' };

  return (
    <Layout>
      <Seo
        {...{ title: seoMetaTitle, description: seoMetaDescription, keywords: seoMetaKeywords }}
      />
      <PageSchema
        type="WebPage"
        name={seoMetaTitle}
        data={{
          metaTitle: seoMetaTitle,
          metaDescription: seoMetaDescription,
          metaKeywords: seoMetaKeywords,
        }}
      />
      <div className="products">
        {productMainBanner?.image ? (
          <div className="banner__hero">
            <Image
              className="w-100 d-none d-md-block"
              imageData={productMainBanner.image}
              alt={productMainBanner.image.altText}
            />
            <Image
              className="w-100 d-md-none"
              imageData={productMainBanner.imageMobile}
              alt={productMainBanner.imageMobile.altText}
            />
            <DangerouslySetInnerHtml
              className="banner__title"
              html={productMainBanner.description}
            />
          </div>
        ) : null}
        {slider ? (
          <ConditionalTextSlider slider={slider} className={customClassName || ''} />
        ) : null}

        <div className="content container">
          <h2 className="products__title-page">{titlePage}</h2>

          {section.map(({ title, extraClass, products }) => (
            <div key={title} className={`row products__row  ${extraClass}`}>
              <div className="col-12">
                <h3 className="products__title-section" key={title}>
                  {title}
                </h3>
              </div>

              {products.map((product) => {
                const { name } = product;

                return (
                  <article className="products__col col-12 col-sm-6 col-md-4" key={name}>
                    <div className={`products__item ${product.cssExtraClass || ''}`}>
                      <ProductListComponent product={product} {...{ purchaseLinkText }} />
                    </div>
                  </article>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default ProductListingComponent;
